import React from 'react';

interface SearchResultCardProps {
  title: string;
  description: string;
  url: string;
  image_url?: string;
  tags?: string[];
  onTrack?: () => void;
}

const SearchResultCard: React.FC<SearchResultCardProps> = ({
  title,
  description,
  url,
  image_url,
  tags = [],
  onTrack
}) => {
  const handleClick = () => {
    if (onTrack) {
      onTrack();
    }
    window.location.href = url;
  };

  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const target = e.currentTarget;
    target.style.display = 'none';
    const parent = target.parentElement;
    if (parent) {
      parent.style.backgroundColor = 'var(--rhea-bg-tertiary)';
    }
  };

  return (
    <div
      onClick={handleClick}
      className="rounded-lg shadow-md hover:shadow-lg transition-all duration-200 hover:scale-[1.02] cursor-pointer w-64 h-64 flex flex-col"
      style={{ 
        backgroundColor: 'var(--rhea-card-bg)',
        border: '1px solid var(--rhea-card-border)'
      }}
    >
      <div className="p-4 flex-1 flex flex-col">
        <div className="flex-1 flex flex-col">
          <div className="flex items-center gap-3 mb-3">
            <div 
              className="w-10 h-10 rounded-lg overflow-hidden flex items-center justify-center flex-shrink-0"
              style={{ backgroundColor: 'var(--rhea-bg-tertiary)' }}
            >
              {image_url ? (
                <img
                  src={image_url}
                  alt={`${title} icon`}
                  className="w-full h-full object-cover"
                  onError={handleImageError}
                />
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  style={{ color: 'var(--rhea-text-secondary)' }}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                  />
                </svg>
              )}
            </div>
            <h3 
              className="text-xl font-semibold"
              style={{ color: 'var(--rhea-text-primary)' }}
            >
              {title}
            </h3>
          </div>
          <p 
            className="mb-4 flex-1 overflow-y-auto"
            style={{ color: 'var(--rhea-text-secondary)' }}
          >
            {description}
          </p>
          {tags.length > 0 && (
            <div className="flex flex-wrap gap-2 mt-auto">
              {tags.map((tag, index) => (
                <span
                  key={index}
                  className="px-2 py-1 text-sm rounded"
                  style={{ 
                    backgroundColor: 'var(--rhea-bg-tertiary)',
                    color: 'var(--rhea-text-secondary)'
                  }}
                >
                  {tag}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchResultCard; 